export default __webpack_public_path__ + "static/media/puna.fa1e0b24.png";